function mobile_menu_open(type){
    /* 1 = menu 2 = search */
    $('body').addClass('stop-scrolling');

    if(type == 1){
        $('.js-mobile-menu-sidebar').addClass('open');
        $('.js-mobile-menu').addClass('open');
    }else{
        $('.js-mobile-search-sidebar').addClass('open');
        $('.js-mobile-search-menu').addClass('open');
        $('.js-mobile-search-input').focus();
        $('.js-mobile-menu').removeClass('open');
    }
    show_overlay();
}

function mobile_menu_close(type){
    /* 1 = menu 2 = search */

    $('body').removeClass('stop-scrolling');

    if(type == 1){
        $('.js-mobile-menu-sidebar').removeClass('open');
        $('.js-mobile-menu').removeClass('open');
        $('.sub-menu.active').removeClass('active');
        $('.mobile-menu-back').hide();
    }else{
        $('.js-mobile-search-sidebar').removeClass('open');
        $('.js-mobile-search-menu').removeClass('open');
    }
    hide_overlay();
}

$(document).ready(function(){
    $('.js-mobile-menu').click(function(){
        mobile_menu_close(2);

        if( $('.js-mobile-menu').hasClass('open') ){
            mobile_menu_close(1);
        }else {
            mobile_menu_open(1);
        }
    })

    $('.js-mobile-search-menu').click(function(){
        mobile_menu_close(1);

        if($('.js-mobile-search-menu').hasClass('open')){
            mobile_menu_close(2);
        }else{
            mobile_menu_open(2);
        }
    })
    /* mobile navigation */

    $('.js-mobile-menu-sidebar li.menu-item-has-children > .js-move-menu').click(function(){
        $(this).closest('.sub-menu.last').removeClass('last');
        $(this).siblings('.sub-menu').addClass('active last');
        return false;
    })

    $('.js-mobile-menu-sidebar .js-mobile-back').click(function(){
        let last_sub_menu = $('.sub-menu.last');
        last_sub_menu.parent().closest('.sub-menu').addClass('last');
        last_sub_menu.removeClass('active last');
    })
});
